import { Link, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { AudiqWordmark, AudiqMark, ThemeToggle, RuleBicolor } from '@audiq/ui';
import { LangSwitcher } from '../components/LangSwitcher';
import { useKiosk, requestKioskFullscreen } from '../lib/kiosk';

export function LandingPage() {
  const { t } = useTranslation();
  const { enabled: kioskEnabled, welcomeMessage, branding } = useKiosk();
  const navigate = useNavigate();

  // Click sul tap-target chiama fullscreen + va a /start (in kiosk).
  async function handleStart() {
    if (kioskEnabled) {
      await requestKioskFullscreen();
    }
    navigate('/start');
  }

  if (kioskEnabled) {
    // Layout kiosk dedicato: nessun toggle theme/back, AudiqMark grande, tap-target dominante.
    return (
      <div
        className="flex min-h-dvh flex-col"
        style={{ background: 'var(--surface)', color: 'var(--ink)' }}
      >
        <header className="flex items-center justify-between p-4">
          <AudiqWordmark size="sm" />
          <LangSwitcher />
        </header>
        <main
          onClick={handleStart}
          className="flex flex-1 items-center justify-center px-6 pb-16 cursor-pointer select-none"
        >
          <div className="w-full max-w-lg text-center">
            <div className="mx-auto mb-8 flex justify-center">
              <AudiqMark size={160} state="idle" />
            </div>
            <h1 className="serif mb-4 text-5xl" style={{ color: 'var(--ink)' }}>
              {welcomeMessage ?? t('kiosk.welcome', 'Benvenuto. Tocca per iniziare.')}
            </h1>
            <RuleBicolor className="mx-auto my-6 max-w-[14rem]" />
            <p className="mono text-sm" style={{ color: 'var(--mute)' }}>
              {t('kiosk.tapHint', 'Tocca lo schermo')}
            </p>
          </div>
        </main>
        <footer className="p-4 text-center mono text-xs" style={{ color: 'var(--mute)' }}>
          Powered by <AudiqWordmark size="sm" /> · {branding?.organization_name ?? ''}
        </footer>
      </div>
    );
  }

  return (
    <div
      className="flex flex-1 flex-col"
      style={{ background: 'var(--surface)', color: 'var(--ink)' }}
    >
      <header className="flex items-center justify-between p-4">
        <AudiqWordmark size="md" />
        <div className="flex items-center gap-2">
          <LangSwitcher />
          <ThemeToggle size="sm" />
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-6 pb-12">
        <div className="w-full max-w-md text-center">
          <div className="mx-auto mb-6 flex justify-center">
            <AudiqMark size={96} state="idle" />
          </div>

          <h1 className="serif mb-3 text-5xl" style={{ color: 'var(--ink)' }}>
            {t('landing.title')}
          </h1>
          <p className="mb-2 text-base" style={{ color: 'var(--mute)' }}>
            {t('landing.subtitle')}
          </p>

          <RuleBicolor className="mx-auto my-6 max-w-[12rem]" />

          <Link
            to="/start"
            className="inline-block rounded-md px-6 py-3 text-base font-medium"
            style={{ background: 'var(--primary)', color: '#fff' }}
          >
            {t('landing.cta')}
          </Link>
        </div>
      </main>

      <footer className="p-4 text-center mono" style={{ color: 'var(--mute)' }}>
        {t('landing.footer')}
      </footer>
    </div>
  );
}
